import { all } from "redux-saga/effects";
import AllAllergiesSaga from "./AllAllergiesSaga";
import AllSavedPrescriptionsSaga from "./AllSavedPrescriptionsSaga";
import EPAHoldingQueueCountSaga from "./EPAHoldingQueueCountSaga";
import EPAHoldingQueueDetailsSaga from "./EPAHoldingQueueDetailsSaga";
import EPAWorklistCountSaga from "./EPAWorklistCountSaga";
import EPAWorklistDetailsSaga from "./EPAWorklistDetailsSaga";
import EPCSQueueSaga from "./EPCSQueueSaga";
import FavDrugsSaga from "./AllFavDrugsSaga";
import TicketsSaga from "./TicketsSaga";
import InitializeTicketSaga from "./InitializeTicketSaga";
import LoginSaga from "./LoginSaga";
import MedicationHistorySaga from "./MedicationHistorySaga";
import NotificationSaga from "./NotificationSaga";
import PostDatedPresCountSaga from "./PostDatedPresCountSaga";
import PostDatedPresDetailsSaga from "./PostDatedPresDetailsSaga";
import PrescriberDetailsSaga from "./PrescriberDetailsSaga";
import SavedPrescriptionsSaga from "./SavedPrescriptionsSaga";
import FavoritePharmacyDataListSaga from "./FavoritePharmacyDataListSaga";
import DrugSearchAjaxSaga from "./DrugSearchAjaxSaga";
import RxChangeAlertsSaga from "./RxChangeAlertsSaga";
import RxChangeAlertsDetailsSaga from "./RxChangeAlertsDetailsSaga";
import RxFillAlertsCountSaga from "./RxFillAlertsCountSaga";
import RxFillAlertsDetailsSaga from "./RxFillAlertsDetailsSaga";
import RefillAlertsCountSaga from "./RefillAlertsCountSaga";
import RefillAlertsListSaga from "./RefillAlertsListSaga";
import GlobalDropdownSaga from "./GlobalDropdownSaga";
import RxAlertsCountSaga from "./RxAlertsCountSaga";
import RxAlertsDetailsSaga from "./RxAlertsDetailsSaga";
import PatientDetailsSaga from "./PatientDetailsSaga";
import TopRibbonSaga from "./TopRibbonSaga";
import UserServicesSaga from "./UserServicesSaga";
import LogoutSaga from "./LogoutSaga";
import PharmacyDropDownSaga from "./PharmacyDropDownSaga";

export default function* RootSaga() {
  yield all([...LoginSaga]);
  yield all([...LogoutSaga]);
  yield all([...NotificationSaga]);
  yield all([...AllSavedPrescriptionsSaga]);
  yield all([...TicketsSaga]);
  yield all([...InitializeTicketSaga]);
  yield all([...SavedPrescriptionsSaga]);
  yield all([...EPCSQueueSaga]);
  yield all([...MedicationHistorySaga]);
  yield all([...PostDatedPresCountSaga]);
  yield all([...PostDatedPresDetailsSaga]);
  yield all([...AllAllergiesSaga]);
  yield all([...FavDrugsSaga]);
  yield all([...EPAHoldingQueueCountSaga]);
  yield all([...EPAHoldingQueueDetailsSaga]);
  yield all([...EPAWorklistCountSaga]);
  yield all([...EPAWorklistDetailsSaga]);
  yield all([...PrescriberDetailsSaga]);
  yield all([...FavoritePharmacyDataListSaga]);
  yield all([...DrugSearchAjaxSaga]);
  yield all([...RxChangeAlertsSaga]);
  yield all([...RxChangeAlertsDetailsSaga]);
  yield all([...RxFillAlertsCountSaga]);
  yield all([...RxFillAlertsDetailsSaga]);
  yield all([...RefillAlertsCountSaga]);
  yield all([...RefillAlertsListSaga]);
  yield all([...GlobalDropdownSaga]);
  yield all([...RxAlertsCountSaga]);
  yield all([...RxAlertsDetailsSaga]);
  yield all([...PatientDetailsSaga]);
  yield all([...TopRibbonSaga]);
  yield all([...UserServicesSaga]);
  yield all([...PharmacyDropDownSaga]);
}
